'use client';
import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const FieldDisplay = styled.div`
  flex: 1;
  display: flex;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  font-family: var(--font-family-mono);

  & > * {
    padding: 2px;
    border-radius: 4px;

    &.added {
      color: ${colors.semantic.diff.added.indicator};
      background: ${toRgba(colors.semantic.diff.added.indicator, 0.1)};
    }
    &.removed {
      color: ${colors.semantic.diff.removed.indicator};
      background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    }
  }
`;

export const Field = styled.div<{ $hasAssociation?: boolean; $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  gap: 10px;

  & > * {
    flex: 0;
    align-items: center;
  }

  & > .content {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
  }
`;

export const FieldDirection = styled.div`
  display: flex;
  align-items: center;
  gap: 0;

  & > * {
    color: transparent;
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 2px;
    &.added.right {
      color: ${colors.semantic.diff.added.indicator};
      background: ${toRgba(colors.semantic.diff.added.indicator, 0.1)};
    }
    &.removed.left {
      color: ${colors.semantic.diff.removed.indicator};
      background: ${toRgba(colors.semantic.diff.removed.indicator, 0.1)};
    }
    &.match {
      color: ${colors.primary.black};
    }
    &.left {
      margin-right: -3px;
    }
    &.right {
      margin-left: -3px;
    }
  }
`;
